import { AbstractLogger } from './components/AbstractLogger';
import { SilentLogger } from './components/SilentLogger';
import type { LogContext, Team } from './types';
import { getApp, isDefaultAppInitialized } from '../sdk/sdk';

class Logger extends AbstractLogger {
  private getLogger(): AbstractLogger {
    if (isDefaultAppInitialized()) {
      return getApp().logger;
    }

    // If the app is not initialized, return a silent logger
    return new SilentLogger();
  }

  public refreshContext(context: LogContext) {
    this.getLogger().refreshContext(context);
  }

  public log(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ) {
    this.getLogger().log(message, teams, ...optionalParams);
  }

  public error(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ) {
    this.getLogger().error(message, teams, ...optionalParams);
  }

  public success(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ) {
    this.getLogger().success(message, teams, ...optionalParams);
  }

  public info(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ) {
    this.getLogger().info(message, teams, ...optionalParams);
  }
}

export const logger = new Logger();

export default logger;
